import { render, staticRenderFns } from "./router-nav.vue?vue&type=template&id=27db58fa&scoped=true"
import script from "./router-nav.vue?vue&type=script&lang=js"
export * from "./router-nav.vue?vue&type=script&lang=js"
import style0 from "./router-nav.vue?vue&type=style&index=0&id=27db58fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27db58fa",
  null
  
)

export default component.exports